import { Activity } from 'types/interfaces/activity';
import { SidebarTradeCard } from 'screens/Public/UserProfile/context/ProfileTradeSidebarContext';

/**
 * Map a want_added/available activity item onto the SidebarTradeCard shape ComposeTradeModal
 * pre-stages. Mirrors Trade Alerts' `alertToStagedCard`: the wanter's acceptance criteria
 * (present on want/available items) flow through so the modal's version flyout shows the real
 * set/finish/condition/language options; when absent the modal falls back to the single
 * displayed printing. `wantEntryId` is the wanter's want-list entry id.
 */
export const activityToStagedCard = (activity: Activity): SidebarTradeCard => {
  const { card } = activity;
  return {
    id: `activity-${activity.id}`,
    wantListId: activity.wantEntryId ?? 0,
    cardId: card.id,
    cardName: card.name,
    set: card.setCode,
    setCode: card.setCode,
    condition: 'NEAR_MINT',
    language: 'en',
    foil: card.foil,
    imageUrl: card.imageUrl,
    pointValue: activity.pointValue ?? 0,
    scryfallId: card.scryfallId,
    acceptFoil: card.acceptFoil ?? true,
    acceptNonFoil: card.acceptNonFoil ?? true,
    availableInFoil: card.availableInFoil ?? card.foil,
    availableInNonFoil: card.availableInNonFoil ?? !card.foil,
    acceptableSetDetails: card.acceptableSetDetails,
    acceptableConditions: card.acceptableConditions,
    acceptableLanguages: card.acceptableLanguages,
    availableLanguages: card.availableLanguages,
    maxQuantity: 1,
  };
};
